module.exports = __webpack_public_path__ + "static/media/squared.3692b91c.jpg";